module.exports = __webpack_public_path__ + "static/img/banner2.40677c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/comm/images/document-conversion/home/banner2.png
// module id = CdKg
// module chunks = 2